import React from 'react';
import './Marquee.css';

const Marquee = () => {
  return (
    <div className="marquee-container">
      <p className="marquee-text">This website is still in development. Check back for updates!</p>
    </div>
  );
};

export default Marquee;
